import { Currency, Lang, User } from 'types';
import store from '../../store';
import { get as getCookie } from 'es-cookie';

export namespace NetworkHelper {
  export const LEGACY_SESSION = 'x-session-id';
  export const LEGACY_USERID = 'x-user-id';
  export const SESSIONID = 'session';
  export const AUTH = 'auth';

  export function getCurrency(): Currency.CurrencyItem {
    return store.state.support.currency as Currency.CurrencyItem;
  }

  export function getLocale() {
    return store.state.support.lang.locale || Lang.DEFAULT_LANG();
  }

  export function getCountry() {
    try {
      const userCountry = getCountryFromUser();
      const locale = getLocale();

      const country = (
        userCountry || locale.locale.split('-')[1]
      ).toUpperCase();

      if (country === 'GB') {
        return 'UK';
      }

      return country;
    } catch (e) {
      return 'UK';
    }
  }

  export function getCountryFromUser() {
    const user: User.UserV2 = store.state.user.userV2;
    return user.country;
  }

  export function saveAuthCredentials(model: User.ML.Response.Auth) {
    localStorage.setItem(AUTH, JSON.stringify(model));
  }

  function getAuth(): User.ML.Response.Auth | null {
    try {
      const auth = localStorage.getItem(AUTH);

      return JSON.parse(auth) as User.ML.Response.Auth;
    } catch (e) {
      return null;
    }
  }

  function legacyCredentials(): Partial<User.ML.Response.Auth> | undefined {
    const sessionId = localStorage.getItem(NetworkHelper.LEGACY_SESSION);
    const userId = localStorage.getItem(NetworkHelper.LEGACY_USERID);

    if (!sessionId || !userId) {
      return undefined;
    }

    return {
      sessionId: sessionId,
      userId: userId,
      legacy: true,
    };
  }

  export function getAuthCredentials():
    | Partial<User.ML.Response.Auth>
    | undefined {
    const auth = getAuth();
    const legacy = legacyCredentials();

    if (auth && auth.sessionId) {
      return auth;
    } else if (legacy && legacy.sessionId) {
      return legacy;
    }
    return undefined;
  }

  export function authed(): boolean {
    const auth = getAuthCredentials();

    return !!(auth && auth.sessionId && auth.userId);
  }

  export function clearCredentials() {
    localStorage.removeItem(NetworkHelper.LEGACY_SESSION);
    localStorage.removeItem(NetworkHelper.LEGACY_USERID);
    localStorage.removeItem(NetworkHelper.AUTH);
  }

  export const getUTMParams = () => {
    const params = {};
    if (getCookie('utm_source')) params['utm_source'] = getCookie('utm_source');
    if (getCookie('utm_medium')) params['utm_medium'] = getCookie('utm_medium');
    if (getCookie('utm_campaign'))
      params['utm_campaign'] = getCookie('utm_campaign');
    if (getCookie('utm_term')) params['utm_term'] = getCookie('utm_term');
    if (getCookie('utm_content'))
      params['utm_content'] = getCookie('utm_content');
    return params;
  };
}
